module.exports = __webpack_public_path__ + "img/screen-11.ec74d3d6.jpg";